// extracted by mini-css-extract-plugin
export default {"root":"DZ9R3nXKfI","locationLink":"_aFtDZO7Ha","location":"ckjxiXu2l0","locationIcon":"PkaA_NE3Cs","locationSegment":"ZfWv3MbJ1y","actions":"cOHxuj7fIa"};